// extracted by mini-css-extract-plugin
export default {"root":"Tools_root__CLPhB","btn":"Tools_btn__8WHH-","menu":"Tools_menu__3zsk4","menuItem":"Tools_menuItem__+V0+m","tip":"Tools_tip__i+M0i"};